
  import { mapGetters } from 'vuex';

  export default {
    props: { basePath: { type: String, required: true } },
    computed: {
      ...mapGetters('providers', { providers: 'getList' })
    },
    methods: {
      separator (index) {
        if (this.providers.length === index + 1) {
          return '';
        }
        if (this.providers.length === index + 2) {
          return `${this.providers.length > 2 ? ',' : ''} and `;
        }
        return ', ';
      }
    }
  };
